import { render } from "./OperacoesTable.vue?vue&type=template&id=63ed2098&ts=true"
import script from "./OperacoesTable.vue?vue&type=script&lang=ts"
export * from "./OperacoesTable.vue?vue&type=script&lang=ts"

import exportComponent from "F:\\Projetos 2024\\e-logDash\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__